<template>
  <div class="mp3-tool">
    <img src="@/assets/image/zanting.png" class="audio-image" v-if="playStatus" alt="" @click="play()">
    <img src="@/assets/image/bofang.png" class="audio-image" v-else alt="" @click="play()">
    <div style="display: flex;align-items: center;">
      <el-select size="mini" v-model="playbackRate" placeholder="请选择" @change="changePlaybackRate">
        <el-option
          v-for="item in playbackRates"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="audio_container">
      <div class="audio_container_box">
        <div class="audio_container_box_jindu progress-container" @click="seek($event)">
          <div class="jindu" :style="{ width: scrollerwidth }"></div>
        </div>
        <div class="audio_container_box_time">{{ timeLength }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    srcUrl: {
      default: ""
    }
  },

  data() {
    return {
      audio:         null,
      playStatus:    false,//播放状态
      isAudioReady:  false,
      rafId:         null,
      duration:      0,  //音频时长
      left:          0,//剩余时长
      scrollerwidth: "0%",      //进度条
      timer:         null,      //定时器
      playbackRate: 1.0,
      playbackRates: [
        {
          label: 'x2.0',
          value: 2.0
        },
        {
          label: 'x1.5',
          value: 1.5
        },
        {
          label: 'x1.25',
          value: 1.25
        },
        {
          label: 'x1.0',
          value: 1.0
        },
        {
          label: 'x0.75',
          value: 0.75
        },
        {
          label: 'x0.5',
          value: .5
        }
      ]
    }
  },
  computed: {
    timeLength: {
      get() {
        return this.convertToTime(parseInt(this.left));
      },
      set(value) {
        console.log('value',value);
        return parseInt(value)
      }
    }
  },
  watch:    {
    left:   {
      handler(newValue) {
        console.log('newValue',newValue);
        this.timeLength = this.convertToTime(parseInt(newValue))
        console.log('timeLength',this.timeLength);
        this.scrollerwidth = this.computedPer()
      }
    },
    srcUrl: {
      handler(newValue) {
        console.log('音乐返回值', newValue)
        this.initAudio()
      }
    }
  },

  created() {
    this.initAudio()
  },
  destroyed() {
    if (this.audio) {
      this.audio.pause();
    }
    this.stopProgressLoop()
    clearInterval(this.timer)
  },
  methods: {
    seek(event) {
      if(this.playStatus) {
        const progressContainer = this.$el.querySelector('.progress-container');
        const rect = progressContainer.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const width = rect.width;
        const newTime = (offsetX / width) * this.duration;
        this.audio.currentTime = newTime;
        let that =this;
        setTimeout(function(){
          that.left = that.duration - newTime;
        },100);
      }
    },
    changePlaybackRate(e) {
      this.audio.playbackRate = this.playbackRate;
    },
    normalizeSrcUrl(url) {
      if (!url || typeof url !== 'string') {
        return ''
      }
      return url.replace(/^https?:\/\/static\.yijishen\.com/i, 'https://cdnstatic.yijishen.com')
    },
    stopProgressLoop() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId)
        this.rafId = null
      }
    },
    startProgressLoop(syncAudioState) {
      this.stopProgressLoop()
      const loop = () => {
        if (!this.audio || this.audio.paused || this.audio.ended) {
          this.rafId = null
          return
        }
        syncAudioState()
        this.rafId = requestAnimationFrame(loop)
      }
      this.rafId = requestAnimationFrame(loop)
    },
    //初始化音频文件
    initAudio() {
      let _ = this;
      if (_.srcUrl === "") {
        console.log('src-url未设置,没有音频文件');
        return;
      }
      if (_.audio) {
        _.audio.pause();
      }
      _.audio = new Audio();
      _.stopProgressLoop()
      _.audio.preload = 'auto'
      _.audio.src = _.normalizeSrcUrl(_.srcUrl);
      _.isAudioReady = false
      _.duration = 0
      _.left = 0
      _.scrollerwidth = '0%'

      const syncAudioState = () => {
        const duration = Number(_.audio.duration || 0)
        const currentTime = Number(_.audio.currentTime || 0)
        if (duration > 0) {
          _.duration = duration
          _.left = Math.max(0, duration - currentTime)
          _.timeLength = _.convertToTime(_.left)
          _.scrollerwidth = _.computedPer()
        }
      }

      const markReady = () => {
        _.isAudioReady = true
        syncAudioState()
        _.$emit("showDuration", _.duration);
      }

      _.audio.addEventListener('loadedmetadata', markReady)
      _.audio.addEventListener('durationchange', syncAudioState)
      _.audio.addEventListener('canplay', markReady)
      _.audio.addEventListener('canplaythrough', markReady)
      _.audio.addEventListener('play', function () {
        _.playStatus = true
        _.startProgressLoop(syncAudioState)
      })
      _.audio.addEventListener('pause', function () {
        _.stopProgressLoop()
        if (!_.audio.ended) {
          _.playStatus = false
        }
      })
      _.audio.addEventListener('error', function () {
        _.stopProgressLoop()
        _.playStatus = false
      })
      _.audio.addEventListener('timeupdate', syncAudioState)
      _.audio.addEventListener('ended', function () {
        _.stopProgressLoop()
        _.playStatus = false
        _.left = 0
        _.timeLength = '00:00:00'
        _.scrollerwidth = '100%'
        clearInterval(_.timer)
      })
    },
    //播放暂停
    play() {
      let _ = this;
      if (this.audio === null) {
        alert("请配置音频资源");
        return
      }
      if (_.playStatus) {
        //暂停
        _.stopProgressLoop()
        _.audio.pause()
        _.playStatus = false
        clearInterval(this.timer)
      } else {
        _.audio.playbackRate = _.playbackRate;
        if (_.audio.readyState < 2) {
          _.audio.load()
        }
        const playPromise = _.audio.play()
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(() => {
            _.playStatus = true
          }).catch(() => {
            _.playStatus = false
          })
        } else {
          _.playStatus = true
        }
      }
      _.$emit("showPlayStatus", _.playStatus);
    },
    //停止播放
    stop() {
      let _ = this;
      if (this.audio === null) {
        return
      }
      if (_.playStatus) {
        _.stopProgressLoop()
        _.audio.pause()
        _.audio.currentTime = 0
        _.playStatus = false
        _.left = _.duration
        clearInterval(_.timer)
        _.$emit("showPlayStatus", _.playStatus);
      }
    },
    convertToTime(times) {
      if (typeof times === 'number') {
        if (times <= 0) {
          return '00:00:00';
        } else {
          let hh = parseInt(times / 3600); //小时
          let shh = times - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (hh < 10 ? '0' + hh : hh) + ':' + (ii < 10 ? '0' + ii : ii) + ':' + (ss < 10 ? '0' + ss : ss);
        }
      } else {
        return '00:00:00';
      }
    },
    computedPer() {
      if (!this.duration) {
        return '0%'
      }
      let per = ((this.duration - this.left) / this.duration) * 100
      return `${Math.max(0, Math.min(100, per)).toFixed(2)}%`;
    }
  }
}
;
</script>
<style scoped>
.mp3-tool {
  display: flex;
}

.audio-image {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}

.audio_container {
  padding-left: 20px;
  width: 100%;
}

.audio_container_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.audio_container_box_jindu {
  width: 100%;
  height: 6px;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(238, 238, 238, 1);
  margin-right: 10px;
}

.jindu {
  height: 100%;
  border-radius: 5px;
  background: rgba(246, 112, 75, 1);
  transition-duration: 1s;
}

.audio_container_box_time {
  margin-right: 10px;
}
.el-select {
  width: 80px;
}
</style>
